import { Tooltip } from "@au-schein-de/au-ui-library";
import type { ReactNode } from "react";

type FilterHeaderProps = {
	title: string;
	value?: number | string;
	icon: ReactNode;
	tooltipInfo?: string;
};

export const FilterHeader = ({
	title,
	value,
	icon,
	tooltipInfo,
}: FilterHeaderProps) => {
	const shouldRenderValue =
		(typeof value === "number" && value > 0) ||
		(typeof value === "string" && !!value);

	return (
		<span className="flex items-center gap-2">
			{icon && <div className="text-ansay-main">{icon}</div>}
			<span className="flex items-center gap-1">
				{title}
				{tooltipInfo && (
					<Tooltip.Info
						info={tooltipInfo}
						iconClassName="text-ansay-main"
						tooltipClassName="max-w-70 bg-white shadow-[0_4px_20px_0_#212A361A]"
						hasArrow={true}
						arrowClassName="fill-white"
					/>
				)}
			</span>

			{shouldRenderValue && (
				<span className="text-body-sm text-gray-500">({value})</span>
			)}
		</span>
	);
};
